<template lang="pug">
form-item-wrapper(v-bind="bind", :rules="rules", :class="formItemClass")
  .readonly-mode-field(v-if="isReadMode") {{ formatLabel }}
  el-input(v-else-if="inputProps.disabled", :value="formatLabel", disabled, readonly)
  el-select.width-full(
    v-bind="inputProps",
    v-show="isEdit",
    ref="fieldEditor",
    :class="{ plus: showDialogBtn }",
    :value="formatValue",
    @input="setValue",
    @focus="handleFocusCustomEvent",
    @change="emitValidate",
    @blur.native.capture="handleBlurCustomEvent"
  )
    el-option(v-for="{ [cnKey]: cnName, [idKey]: id } in list", :key="id", :label="cnName", :value="id")
  i.more-btn.el-icon-copy-document(v-if="showDialogBtn", @click="openDialog")
</template>
<script>
import { pick } from "lodash-es";
import { getDataListByMeta } from "@/CommonDP/service/vform-meta-data.js";
import { cloneDeep, setWidgetValue, staticMixins, V_FORM_ENUM } from "@/CommonDP/VForm/utils";
import { mapState } from "vuex";
import { getDSByName, runDataSourceRequest } from "./utils";
import asyncCom from "@/CommonDP/commons/asyncCom";
export default {
  mixins: [staticMixins],
  data() {
    return { list: [], rules: [], splitter: "," };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    dsTriggerForm() {
      const {
        subFormPrefix,
        options: { dsTriggerFields }
      } = this;
      const inSub = !!subFormPrefix;
      const list = dsTriggerFields || [];
      const formRef = this.getFormRef();
      const data = {};
      if (!formRef) return data;
      for (const key of list) {
        const isSubKey = subFormPrefix ? key.indexOf(subFormPrefix) !== -1 : false;
        if (!isSubKey) {
          data[key] = cloneDeep(this.formModel[key]);
        } else if (isSubKey && inSub) {
          data[key] = cloneDeep(this.curFieLdForm[key]);
        }
      }
      return data;
    },
    showDialogBtn() {
      const {
        isEdit,
        options: { dsEnabled, columnField = [] }
      } = this;
      return isEdit && !dsEnabled && !!columnField?.length;
    },
    localAssignLabel() {
      const {
        cnKey,
        curFieLdForm,
        options: { assignData }
      } = this;
      if (cnKey && assignData?.length) {
        const key = assignData.find(({ from }) => from === cnKey)?.to;
        return curFieLdForm?.[key];
      }
      return undefined;
    },
    // 如果在从表下,返回从表前缀,否则为空字符串
    subFormPrefix() {
      const {
        subFormOptions: { sublist, fieldNum }
      } = this;
      return sublist ? `${sublist}_${fieldNum}-` : "";
    },
    // 配置的sql查询
    exprGroupList() {
      return this.options.exprGroupList || [];
    },
    // sql中需要依赖本表的字段列表
    //  [[],[]] 主表字段,从表字段
    triggerField() {
      const { exprGroupList } = this;
      // 2 3代表着查询的数据来源属于主/从
      return [2, 3].map((field_index) => {
        const list = new Set();
        for (const { exprList } of exprGroupList) {
          for (const { value, value2, valueSource } of exprList) {
            if (valueSource === field_index) {
              for (const key of [value, value2]) {
                if (key) list.add(key.slice(1, -1));
              }
            }
          }
        }
        return [...list];
      });
    },
    // 额外数据 当前登录的数据
    sqlParams() {
      return {
        prjId: this.prjId,
        enterpriseId: this.enterpriseId
      };
    },
    // 格式化后的 从表字段
    sqlSubFields() {
      const {
        triggerField: [, fields],
        subFormPrefix
      } = this;
      return fields.map((str) => `${subFormPrefix}${str}`);
    },
    sqlMainFields() {
      return this.triggerField[0];
    },
    // sql内数据
    sqlData() {
      const { curFieLdForm, sqlMainFields, formModel, sqlSubFields, triggerField } = this;
      const obj = { formData: {}, subForm: {}};
      const fieldTem = [{ fields: sqlMainFields, form: formModel, data: obj.formData }];
      if (sqlSubFields?.length) {
        fieldTem.push({ fields: sqlSubFields, form: curFieLdForm, data: obj.subForm });
      }
      for (let i = 0; i < fieldTem.length; i++) {
        const { data, form, fields } = fieldTem[i];
        // 从表表单字段是格式化后的,但是整理提交的字段是格式化前的,所以需要转换一下
        const sortFields = triggerField[i];
        for (let j = 0; j < fields.length; j++) {
          const field = fields[j];
          const sort = sortFields[j];
          data[sort] = form[field];
        }
      }
      return obj;
    },
    inputProps() {
      const { multiple, options } = this;
      const propKey = ["labelAlign", "placeholder", "size", "disabled", "disabled", "clearable", "filterable", "multipleLimit"];
      const props = pick(options, propKey);
      props.multiple = multiple;
      return props;
    },
    modelLabel() {
      return this.getLabelByModel();
    },
    formatLabel() {
      return this.localAssignLabel || this.modelLabel;
    },
    idKey() {
      const {
        options: { valueField }
      } = this;
      return valueField;
    },
    cnKey() {
      const {
        options: { titleField, valueField }
      } = this;
      return titleField || valueField;
    },
    // 发起查询时提交的数据
    metaParams() {
      const {
        cnKey,
        idKey,
        sqlData,
        subFormTableId,
        options: { tableId: tableName, assignData, columnField = [], filterField = [], name }
      } = this;
      const { formId } = this.getGlobalDsv();
      const fields = new Set([...columnField, ...filterField, cnKey, idKey]);
      for (const { from } of assignData) {
        fields.add(from);
      }
      return {
        formId,
        tableName,
        ...sqlData, // 主&从表填写的数据
        subTableName: subFormTableId,
        formFieldId: name,
        queryFieldList: [...fields]
      };
    },
    //  从表配置
    subFormOptions() {
      let vm = this.$parent;
      while (vm) {
        if (["CustomSubFormWidget", "CustomSubFormItem"].indexOf(vm.$options.name) === -1) {
          vm = vm.$parent;
        } else {
          return vm.widget.options;
        }
      }
      return {};
    },
    subFormTableId() {
      const { subFormOptions } = this;
      return subFormOptions.sublist;
    },
    multiple() {
      return this.options.multiple2;
    },
    curItems() {
      const { list, formatValue, idKey } = this;
      return []
        .concat(formatValue)
        .filter((d) => d)
        .map((id) => list.find(({ [idKey]: idValue }) => idValue === id))
        .filter((d) => d);
    },
    formatValue() {
      const { fieldModel, multiple, splitter } = this;
      if (multiple) {
        return fieldModel ? fieldModel.split(splitter) : [];
      }
      return fieldModel;
    }
  },
  created() {
    this.initSqlItems();
    const {
      designState,
      options: { dsEnabled }
    } = this;
    if (!this.isEdit && !designState && dsEnabled) this.getDSVData();
  },
  methods: {
    async openDialog() {
      const { default: dialog } = await import("./detail.vue");
      const data = await asyncCom(dialog, { fieldVm: this });
      this.fieldModel = data;
    },
    setValue(val, disableChangeEvent) {
      const { splitter } = this;
      const oldValue = cloneDeep(this.fieldModel);
      const newValue = Array.isArray(val) ? val.join(splitter) : val || "";
      this.fieldModel = newValue;
      if (!disableChangeEvent) {
        this.emitFieldDataChange(this.fieldModel, oldValue);
      }
    },
    async getDSVData() {
      const {
        formConfig,
        dsTriggerForm,
        options: { dsName: curDSName }
      } = this;
      const curDS = getDSByName(formConfig, curDSName);
      if (!curDS) return;
      const gDsv = this.getGlobalDsv() || {};
      const localDsv = { ...gDsv, widgetName: this.options.name };
      try {
        const list = await runDataSourceRequest.call(this, curDS, {
          DSV: localDsv,
          isSandbox: false,
          data: dsTriggerForm,
          VFR: this.getFormRef()
        });
        this.list = list;
        this.checkList(list);
      } catch (err) {
        this.$message.error(err.message);
      }
    },
    async getSqlData() {
      const { idKey, metaParams, sqlParams } = this;
      if (!idKey) return;
      const cloneData = cloneDeep(metaParams);
      const d = this.customEvent("onSqlQuery", cloneData);
      const { data } = await getDataListByMeta(cloneData, sqlParams);
      const list = data.filter((d) => d);
      if (d instanceof Function) {
        d.call(this, list);
      }
      this.list = list;
      this.checkList(list);
    },
    initOptionItems() {
      const {
        designState,
        options: { dsEnabled }
      } = this;
      if (designState || !dsEnabled) return;
      this.watchField(this.options.dsTriggerFields, this.getDSVData, this.preventGetList);
    },
    initSqlItems() {
      if (this.vFormMode !== V_FORM_ENUM.runtime || this.options.dsEnabled) return;
      // if (this.fieldModel && !this.localAssignLabel) this.getSqlData();
      this.watchField(this.sqlSubFields, this.getSqlData, this.preventGetList);
      this.watchField(this.sqlMainFields, this.getSqlData, this.preventGetList);
    },
    // 数据模型：对获取的数据和已经选择的旧数据做比较，defaultFirst是否有默认第一条数据
    checkList(list) {
      const { formatValue, fieldModel, idKey, isEdit, isInit, splitter } = this;
      const firstId = this.options.defaultFirst ? list[0]?.[idKey] : "";
      if (!isEdit || isInit) return;
      if (!fieldModel) {
        this.fieldModel = firstId;
        return;
      }
      const idSet = new Set(list.map((item) => item[idKey]));
      const checks =
        []
          .concat(formatValue)
          .filter((d) => d && idSet.has(d))
          .join(splitter) || firstId;
      if (checks !== fieldModel) {
        this.fieldModel = checks;
      }
    },
    preventGetList() {
      return !(this.isEdit || (this.fieldModel && !this.localAssignLabel));
    },
    withUpdate() {
      const {
        curItems,
        splitter,
        options: { assignData }
      } = this;
      if (this.isInit) return;
      const map = {};
      for (const { to, from } of assignData) {
        const list = map[to] || [];
        const value = curItems.map((item) => item?.[from]);
        list.push(value);
        map[to] = list;
      }
      const keys = Object.keys(map);
      for (const key of keys) {
        setWidgetValue.call(this, key, map[key]?.join(splitter));
      }
    },
    getLabelByModel() {
      const { curItems, cnKey, splitter } = this;
      const labelList = curItems.map((item) => item?.[cnKey] || "");
      return labelList.join(splitter);
    }
  }
};
</script>
<style lang="scss" scoped src="./index.scss"></style>
